import React from 'react';
import { motion } from 'framer-motion';
import ScoreGauge from './ScoreGauge';
import MaturityLadder from './MaturityLadder';
import CategoryCard from './CategoryCard';
import AreaRiskChart from './AreaRiskChart';
import ExecutiveSummary from './ExecutiveSummary';
import Recommendations from './Recommendations';
import { CATEGORIES } from '../data/questions';
import { getMaturityLevel } from '../utils/scoreCalculator';
import { downloadAssessmentReport } from '../utils/downloadReport';
import styles from './ResultDashboard.module.css';

export default function ResultDashboard({ overallScore, categoryScores, insights, onRestart }) {
  const maturity = getMaturityLevel(overallScore);
  const chartCategories = CATEGORIES.map((cat) => ({ ...cat, score: categoryScores[cat.key] }));

  return (
    <motion.div
      className={styles.dashboard}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <div className={styles.layout}>
        <aside className={styles.scorePanel}>
          <div className={`${styles.scorePanelCard} aira-card`}>
            <span className={styles.eyebrow}>AI Readiness Score</span>
            <ScoreGauge score={overallScore} maxScore={100} color={maturity.color} />
            <motion.span
              className={styles.maturityBadge}
              style={{ borderColor: maturity.color, color: maturity.color }}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
            >
              {maturity.label}
            </motion.span>

            <div className={styles.ladderDivider} />
            <MaturityLadder currentLabel={maturity.label} />
          </div>
        </aside>

        <div className={styles.mainColumn}>
          <h3 className={styles.sectionHeading}>Category Breakdown</h3>
          <div className={styles.categoryGrid}>
            {CATEGORIES.map((cat) => (
              <CategoryCard key={cat.key} categoryKey={cat.key} label={cat.label} score={categoryScores[cat.key]} />
            ))}
          </div>

          <AreaRiskChart categories={chartCategories} />

          <ExecutiveSummary summary={insights.summary} />

          <Recommendations
            strengths={insights.strengths}
            risks={insights.risks}
            recommendations={insights.recommendations}
          />
        </div>
      </div>

      <div className={styles.footer}>
        <button
          type="button"
          className={styles.downloadButton}
          onClick={() => downloadAssessmentReport({ overallScore, categoryScores, insights })}
        >
          ↓ Download Word Report
        </button>
        <button type="button" className={styles.restartButton} onClick={onRestart}>
          Retake Assessment
        </button>
      </div>
    </motion.div>
  );
}
